import { useState } from 'react';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';


function CreateBillLink({ formId, onLoad, onClose }) {

	const [selectedFile, setSelectedFile] = useState([]);
	const [link, setLink] = useState('');
	const [loadbtn, setLoadbtn] = useState(false);
	const [selectedOption, setSelectedOption] = useState('file');
	const { iden: iuser, mail, sapDB } = useSelector((state) => state.user);

	const handleFileChange = (event) => {
		setSelectedFile(Array.from(event.target.files));
	};

	const handleUploadFile = async (file) => {
		if (!file) {
			alert('No se ha seleccionado ningún archivo.');
			return;
		}

		const formData = new FormData();
		selectedFile.forEach((file) => {
			formData.append('files', file);
		});
		formData.append('bilFormId', formId);
		formData.append('auth', iuser);
		formData.append('sapDB', sapDB);
		formData.append('user', mail);

		try {
			const response = await fetch(apiurl + `uploadFileToBill`, {
				method: 'POST',
				credentials: 'include',
				body: formData
			});
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			await onLoad();
			onClose();
		} catch (error) {
			console.error('Error uploading file:', error);
			alert('Error al subir el archivo: ' + error.message);
		}
	};

	const onSubmit = (event) => {
		setLoadbtn(true);
		if (selectedOption === 'file') {
			if (selectedFile) handleUploadFile(selectedFile);
		} else if (link) {
			fetch(apiurl + 'tableINSE', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					dbuser: sapDB,
					table: 'bil__link',
					fiels: `iden_form,publ,auth,file`,
					vals: `${formId},now(),${iuser},'${link}'`
				})
			})
				.then(response => response.json())
				.then(data => {
					if (!data[0].error) {
						onLoad();
						onClose();
					}
				})
				.catch(error => {
					console.error('Error:', error);
					alert('Error al crear el enlace: ' + error.message);
				});
		}
	}

	return (
		<form>
			<orm-modal>
				<dialog open>
					<h2>Agregando adjunto</h2>
					<fieldset>
						<orm-tab>
							<input type="radio" name="atta" id="file" value="file" defaultChecked={selectedOption === 'file' ? true : false} onChange={() => setSelectedOption('file')} />
							<label htmlFor="file">Archivo</label>
							<div>
								<input
									type="file" multiple onChange={handleFileChange}
									placeholder={selectedFile.length > 0 ? `${selectedFile.length} archivo(s) seleccionado(s)` : "Seleccione archivos..."}
								/>
							</div>
							<input type="radio" name="atta" id="link" value="link" defaultChecked={selectedOption === 'link' ? true : false} onChange={() => setSelectedOption('link')} />
							<label htmlFor="link">Enlace</label>
							<div>
								<input type="url" value={link} onChange={(e) => setLink(e.target.value)} />
							</div>
						</orm-tab>
					</fieldset>
					<table>
						<tfoot>
							<tr>
								<td></td>
								<td>
									<input type="button" value="Cancelar" onClick={onClose} />
									<input type="button" value="Agregar" onClick={onSubmit} disabled={loadbtn} />
								</td>
							</tr>
						</tfoot>
					</table>
				</dialog>
			</orm-modal>
		</form>
	)
}



export default CreateBillLink;
